import { useTranslation } from "react-i18next"
import { cn } from "@nexus/ui"

import {
  PERSONA_TYPE_BADGE_BASE,
  personaTypeBadgeClassName,
  personaTypeLabel,
} from "../../lib/persona-type"
import type { PersonaType } from "../../types/personas.types"

export function PersonaTypeBadge({
  type,
  isMainBrand,
  className,
}: {
  type: PersonaType
  isMainBrand?: boolean
  className?: string
}) {
  const { t } = useTranslation()

  return (
    <span className={cn(PERSONA_TYPE_BADGE_BASE, personaTypeBadgeClassName(type), className)}>
      {personaTypeLabel(t, type, isMainBrand)}
    </span>
  )
}
